declare global {
  interface Window {
    ga: {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      getAll: () => Array<any>
    }
  }
}
export const pushAnalyticsEvent = (
  eventCategory: string,
  eventAction: string,
  eventLabel?: string,
  eventValue?: string | number,
): void => {
  if (
    typeof window !== 'undefined' &&
    'ga' in window &&
    window &&
    window.ga &&
    window.ga.getAll &&
    window.ga.getAll() &&
    window.ga.getAll().length > 0
  ) {
    const trackers = window.ga.getAll()
    if (trackers && trackers.length > 0) {
      const tracker = trackers[0]

      if (tracker) {
        tracker.send(
          'event',
          eventCategory,
          eventAction,
          eventLabel,
          eventValue,
        )
      }
    }
  }
}
